import { useMemo, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import {
    Container,
    TitleContainer,
    GalleryGrid,
    GalleryImage,
} from "./gallery.style";

const images = require
    .context("../../assets/img/gallery", false, /\.(jpg|jpeg|png|webp)$/i)
    .keys()
    .map((key) =>
        require.context("../../assets/img/gallery", false, /\.(jpg|jpeg|png|webp)$/i)(key)
    );

export const GalleryContent = () => {
    const [index, setIndex] = useState(-1);
    const slides = useMemo(() => images.map((src) => ({ src })), []);

    return (
        <Container>
            <TitleContainer>
                <h1>Galerie</h1>
            </TitleContainer>

            <GalleryGrid>
                {images.map((src, i) => (
                    <GalleryImage
                        key={i}
                        src={src}
                        alt={`gallery-${i}`}
                        onClick={() => setIndex(i)}
                        loading="lazy"
                    />
                ))}
            </GalleryGrid>

            <Lightbox
                open={index >= 0}
                index={index >= 0 ? index : 0}
                close={() => setIndex(-1)}
                slides={slides}
                on={{ view: ({ index: current }) => setIndex(current) }}
            />
        </Container>
    );
};
